<template>
	<div>
		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.navigation.promotions }}
							</h6>

							<button class="btn btn-primary" v-on:click="create">{{ t.promotion.title.create }}</button>
							<div class="element-box-tp">

								<div class="alert" v-if="status > 200">
									<span v-if="status == 401">
										{{ t.error.access_denied_content }}
									</span>
									<span v-if="status == 404">
										{{ t.error.notfound_content_list }}
									</span>
								</div>

								<table-component

										v-if="status == 200 && w >= 700"
										table-class="table table-padded"
										filter-input-class="form-control col-4 float-right rounded bright"
										:data="promotions"
										sort-by="id"
										sort-order="desc"
								>

									<table-column show="id" label="#" cell-class="w50"></table-column>

									<table-column cell-class="text-center">
										<template slot-scope="row">
											{{ row.type.promotion_mode.name }}
										</template>
									</table-column>

									<table-column cell-class="text-center">
										<template slot-scope="row">
											{{ row.type.name }}
										</template>
									</table-column>

									<table-column :label="t.title" show="title">
									</table-column>

									<table-column :label="t.created_at" cell-class="text-center">
										<template slot-scope="row">
											{{ _df(row.created_at) }}
										</template>
									</table-column>

									<table-column :label="t.end_at" cell-class="text-center">
										<template slot-scope="row">
											{{ _df(row.ended_at) }}
										</template>
									</table-column>

                  <table-column :label="t.active">
                    <template slot-scope="row">
                      <i v-if="row.is_active" class="os-icon os-icon-ui-21 text-success"></i>
                      <i v-if="!row.is_active" class="os-icon os-icon-ui-23 text-danger"></i>
                    </template>
                  </table-column>

									<table-column cell-class="row-actions w50">
										<template slot-scope="row">
											<router-link :to="{params: {id: row.id}, query: $route.query}"><i class="ti-settings"></i></router-link>
										</template>
									</table-column>

								</table-component>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<sweet-modal ref="settings" v-on:close="closeModal">
			<editForm />
		</sweet-modal>

		<sweet-modal ref="new" v-on:close="closeModal">
			<newForm />
		</sweet-modal>
	</div>
</template>

<script>
    import filterGenerator from '@/components/form/filter'
    import { TableComponent, TableColumn } from 'vue-table-component'
    import editForm from '@/components/accounting/promotions/editForm'
    import newForm from '@/components/accounting/promotions/newForm'

    export default {
        name: "list",
        components: { 'table-component': TableComponent, 'table-column': TableColumn, filterGenerator, editForm, newForm},
	    data () {
            return {
                api: window.api,
                w: window.innerWidth,
                isLoading: false,
                promotions: null,
                pagination: null,
                t: this.$root.t,
                status: 0,
                types: null,
                filter: {},
            }
	    },
	    watch: {
            '$route.params.id' () {
                if (this.$route.params.id > 0) {
                    setTimeout( () => {
                        this.$refs.settings.open();
                }, 500)
                }
            },
          '$route.query' () {
              this.fetchPromotions();s
          }
	    },
	    mounted () {
		    this.fetchPromotions();

		    if (this.$route.params.id > 0) {
                this.$refs.settings.open();
		    }
	    },
	    methods: {
            closeModal () {
                this.fetchPromotions();
                this.$router.replace({ params: {id: null}, query: this.$route.query });
                setTimeout( () => {
                    window.document.body.style.overflow = 'auto';
                }, 500);
            },
            create () {
                this.$refs.new.open()
            },
            fetchPromotions () {

                if (!this.isLoading) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/promotions?noCache=1&all=1&full=1', {params: this.$route.query}).then(response => {
                            // get body data
                        this.promotions = response.body.promotions;
                        this.pagination = response.body.pagination;
                        this.isLoading = false;
                        this.status = response.status;

                    }, response => {
                            this.isLoading = false;
                            this.status = response.status;
                    })
                }
            },
	    }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/promotions/list.vue